















import { Vue, Component, Mixins, Prop } from "vue-property-decorator";

import MyList from "@/mixins/list";

import Vips from "./vips.vue";

@Component({
  components: {
    Vips,
  },
})
export default class extends Mixins(MyList) {
  @Prop() stadiumId!: number;
}
